/*  MUI  */
import { Box, Typography } from '@mui/material';

/*  Shared  */
import { ApplicationNameAdminAppModalCell } from 'application/Shared/Components/ApplicationNameAdminAppModalCell';
import {
    LifecyclePicker,
    RiskPicker
} from 'application/Shared/Components/Pickers';

/*  Objects  */
import { Application, ApplicationBusinessOwner } from 'objects/Application';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { QBRReportHeader } from './QBRReportHeader';
import { QBRScoreHistoryAndInsights } from './QBRScoreHistoryAndInsights';

export const QBRFirstAppOverlapScore = (props) => {
    const { t } = useTranslation();
    const { reportData, reportWrapper, runReport } = props;

    const reportType = 'AppOverlapScore';

    return (
        <Box>
            <QBRReportHeader {...{ ...props, reportType }} />
            {!reportWrapper && (
                <QBRScoreHistoryAndInsights
                    reportType={reportType}
                    props={{ ...props }}
                />
            )}

            {Object.keys(reportData.data.overlappedApplications).map(
                (category) =>
                    Object.keys(
                        reportData.data.overlappedApplications[category]
                    ).map((subCategory, index) => {
                        const applications =
                            reportData.data.overlappedApplications[category][
                                subCategory
                            ];
                        return (
                            <Box
                                key={`overlap_category_${category}_${subCategory}`}
                            >
                                <Typography
                                    variant="h4"
                                    style={{ marginTop: '8px' }}
                                >
                                    {`${category} / ${subCategory}`}
                                </Typography>
                                {applications.map((app) => (
                                    <Box
                                        p="8px"
                                        backgroundColor={
                                            index % 2 === 0
                                                ? 'table.evenRowBackground'
                                                : 'table.oddRowBackground'
                                        }
                                        className="noBreak"
                                        key={`${category}_${subCategory}_${app.applicationId}`}
                                    >
                                        <Application data={app.application}>
                                            <Typography
                                                component="span"
                                                style={{
                                                    textTransform: 'uppercase'
                                                }}
                                            >
                                                <ApplicationNameAdminAppModalCell
                                                    onCloseModal={runReport}
                                                    row={app}
                                                />
                                            </Typography>
                                            <div
                                                style={{
                                                    paddingLeft: '20px'
                                                }}
                                            >
                                                <Box mt="8px" style={{}}>
                                                    <Typography
                                                        style={{
                                                            fontWeight: 600
                                                        }}
                                                    >
                                                        {`${t(
                                                            'Common.business_owner'
                                                        )}:`}
                                                    </Typography>
                                                    <ApplicationBusinessOwner
                                                        businessOwnerPlatformUserId={
                                                            app.businessOwnerPlatformUserId
                                                        }
                                                        noBusinessOwnerRequired={
                                                            app.noBusinessOwnerRequired
                                                        }
                                                    />
                                                </Box>
                                                <Box display="flex" mt="8px">
                                                    {!!app.risk && (
                                                        <Box width="50%">
                                                            <Typography
                                                                style={{
                                                                    fontWeight: 600
                                                                }}
                                                            >
                                                                {`${t(
                                                                    'Common.risk'
                                                                )}:`}
                                                            </Typography>
                                                            <RiskPicker
                                                                visualOnly
                                                                value={app.risk}
                                                            />
                                                        </Box>
                                                    )}
                                                    <Box width="50%">
                                                        <Typography
                                                            style={{
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            {`${t(
                                                                'Common.lifecycleStage'
                                                            )}:`}
                                                        </Typography>
                                                        <LifecyclePicker
                                                            visualOnly
                                                            value={app.status}
                                                        />
                                                    </Box>
                                                </Box>
                                                <Typography
                                                    style={{
                                                        fontWeight: 600,
                                                        marginTop: '8px'
                                                    }}
                                                >
                                                    {`${t(
                                                        'Common.business_purpose'
                                                    )}:`}
                                                </Typography>

                                                {app.purpose ? (
                                                    <Typography>
                                                        {app.purpose}
                                                    </Typography>
                                                ) : (
                                                    <Typography color="text.danger">
                                                        {t(
                                                            'Common.no_purpose_set'
                                                        )}
                                                    </Typography>
                                                )}
                                            </div>
                                        </Application>
                                    </Box>
                                ))}
                            </Box>
                        );
                    })
            )}
        </Box>
    );
};
